import * as Constants from '../Constants';
import SwiperJS from '../../../js/vendor/swiper.min.js';
import Swiper, { SelectableElement, SwiperOptions } from 'swiper';
import { ISwiperSettings } from "../../interfaces/ISwiperSettings";

var Acr = window.Acr || {};

var Utility = window.Utility || {};

declare global {
  interface Window {
    Utility: any;
    Acr: any;
  }
}

export function AcrTab() {
  let DeepLink;
  let acrTab: HTMLElement;
  let acrTabList: HTMLElement;
  let acrTabLink: HTMLElement[];
  let acrTabBody: HTMLElement;
  let acrTabHead: HTMLElement;
  let acrTabSection: HTMLElement[];
  let arrowRight: SelectableElement;
  let arrowLeft: SelectableElement;
  let swiperContainer: HTMLElement;
  let swiperPagination: SelectableElement;
  let mediaMatchSwiper: MediaQueryList;
  let tabSettings: ISwiperSettings;
  let swiperUpdateEvent: Event;
  let tabSwiper: Swiper;
  let activeTabSection: HTMLElement;
  const mobileCarouselClass = 'acr-tab--mobile-carousel';
  const tabletCarouselClass = 'acr-tab--tablet-carousel';
  const acrTabBodySelector = '.js-tab-body';
  const acrTabListSelector = '.js-tab-list';
  const acrTabLinkSelector = '.js-tab-link';
  const acrTabHeadSelector = '.js-tab-head';
  const acrTabSectionSelector = '.js-tab-section';
  const jsModuleClass = '.js-module';
  const activeLinkClass = 'acr-tab__link--active';
  const activeSectionClass = 'acr-tab__section--active';
  const swiperContainerClass = '.acr-tab__body.swiper-container';
  const swiperPaginationClass = '.acr-tab__controls-container .js-swiper-pagination';
  const arrowLeftClass = '.acr-tab__controls-container .js-arrow-left';
  const arrowRightClass = '.acr-tab__controls-container .js-arrow-right';

  const setCurrent = (currentNav: HTMLElement, tabId: string) => {
    for (let i: number = 0; i < acrTabLink.length; i++) {
      acrTabLink[i].classList.remove(activeLinkClass);
      acrTabLink[i].setAttribute('aria-selected', 'false');
    };

    currentNav.classList.add(activeLinkClass);
    currentNav.setAttribute('aria-selected', 'true');
    acrTabSection.forEach(e => {
      e.classList.remove(activeSectionClass);
    })
    activeTabSection = acrTabBody.querySelector('*[data-id="' + tabId + '"]');
    activeTabSection.classList.add(activeSectionClass);
  };

  const selectTab = (element: HTMLElement) => {
    var currentLink;
    var slideID;
    currentLink = element;
    slideID = currentLink.getAttribute('tab-id');
    setCurrent(currentLink, slideID);
    resetContent(activeTabSection);
  };

  function initTabs() {
    for (var i = 0; i < acrTabLink.length; i++) {
      acrTabLink[i].addEventListener('click', function (event) {
        var currentSlide = (event.currentTarget as HTMLElement).getAttribute('aria-controls');
        tabChange(currentSlide);
        event.preventDefault();
        selectTab(this);
      })
    }
  }

  const initSelectors = (element: HTMLElement) => {
    acrTab = element;
    acrTabLink = [...acrTab.querySelectorAll(acrTabLinkSelector)] as HTMLElement[];
    acrTabSection = [...acrTab.querySelectorAll(acrTabSectionSelector)] as HTMLElement[];
    acrTabList = acrTab.querySelector(acrTabListSelector);
    acrTabBody = acrTab.querySelector(acrTabBodySelector);
    acrTabHead = acrTab.querySelector(acrTabHeadSelector);
    swiperPagination = acrTab.querySelector(swiperPaginationClass) as HTMLElement;;
    arrowLeft = acrTab.querySelector(arrowLeftClass) as HTMLElement;;
    arrowRight = acrTab.querySelector(arrowRightClass) as HTMLElement;
    swiperContainer = acrTab.querySelector(swiperContainerClass);
  };

  const bindEvents = () => {
    if (tabSettings.SettingMobileSwiper || tabSettings.SettingTabletSwiper) {
      mediaMatchSwiper.addEventListener('change', () => {
        initSwiper;
      });
    }

    window.addEventListener('hashchange', deepLinking);
    window.addEventListener('load', deepLinking);
  };

  const getTabSettings = () => {
    try {
      let defaultTab;
      if (acrTab.dataset.defaultTab) {
        defaultTab = parseInt(acrTab.dataset.defaultTab, 10) - 1;
      }
      tabSettings = JSON.parse(acrTab.getAttribute('data-module-settings'));
      if (defaultTab >= 0 && acrTabLink.length > 1) {
        selectTab(acrTabLink[defaultTab]);
      }
    } catch (err) {
      tabSettings = {};
    }
  };

  const tabChange = (tabName: string) => {
    var trackingData = acrTabHead.getAttribute('data-tracking-no-click');
    if (trackingData && Acr.TrackingManager) {
      var clickObject = JSON.parse(trackingData.split("'").join('"'));
      clickObject.dynamic_variables[0].search += tabName;
      Acr.TrackingManager.clickActivity(clickObject);
    }
  }

  const resetContent = (currentTabSection: HTMLElement) => {
    let modules: HTMLElement[];
    modules = [...currentTabSection.querySelectorAll(jsModuleClass)] as HTMLElement[];
    for (var modulesIndex = 0; modulesIndex < modules.length; modulesIndex++) {
      var moduleId = parseInt(modules[modulesIndex].dataset.moduleId, 10);

      if (moduleId) {
        var currentModule = Acr.Modules[moduleId];
        if (currentModule.reset) {
          currentModule.reset();
        }
      }
    }
    if (acrTab.querySelector('.acr-package-detail__swiper-container')) {
      swiperUpdateEvent = Utility.createEvent('swiperUpdate');
      window.dispatchEvent(swiperUpdateEvent);
    }
  };

  function deepLinking() {
    if (acrTab) {
      var hashTab = DeepLink.getTabIdHashElement(acrTab[0]);
      if (hashTab) {
        selectTab(hashTab);
      }
    }
  }

  const setCarouselClasses = () => {
    if (tabSettings.SettingMobileSwiper) {
      acrTab.classList.add(mobileCarouselClass);
    }
    if (tabSettings.SettingTabletSwiper) {
      acrTab.classList.add(tabletCarouselClass);
    }
  }

  const defineMatchMedia = () => {
    if (tabSettings.SettingMobileSwiper && tabSettings.SettingTabletSwiper) {
      mediaMatchSwiper = window.matchMedia('(max-width:' + (Constants.breakpoints.lg - 1) + 'px)');
    } else if (tabSettings.SettingMobileSwiper) {
      mediaMatchSwiper = window.matchMedia('(max-width:' + (Constants.breakpoints.md - 1) + 'px)');
    } else if (tabSettings.SettingTabletSwiper) {
      mediaMatchSwiper = window.matchMedia('(min-width:' + Constants.breakpoints.md + 'px) and (max-width:' + (Constants.breakpoints.lg - 1) + 'px)');
    } else {
      mediaMatchSwiper = undefined;
    }
  }

  const initSwiper = (mediaMatch: MediaQueryList, event?: MediaQueryListEvent): any => {
    if (mediaMatch && mediaMatch.matches) {
      var slideIndex = acrTab.querySelector('.' + activeLinkClass) ? Utility.index(acrTab.querySelector('.' + activeLinkClass).parentElement) : 0;
      const tabSwiperOptions: SwiperOptions = {
        speed: 400,
        slidesPerView: 1,
        loop: false,
        initialSlide: slideIndex,
        pagination: {
          el: swiperPagination,
          clickable: true,
          type: 'custom',
          bulletClass: 'acr-tab__bullet',
          renderCustom: renderTabMobile,
          bulletActiveClass: 'acr-tab__bullet-active',
        },
        on: {
          slideChange: function () {
            if (acrTab.querySelector('.swiper-container')) {
              var selectedTabId = (swiperPagination as HTMLElement).querySelector('.js-tab-link') ? (swiperPagination as HTMLElement).querySelector('.js-tab-link').getAttribute('tab-id') : undefined;
              var selectedTab = acrTabList.querySelector('[tab-id="' + selectedTabId + '"]') as HTMLElement;
              if (selectedTab) {
                selectTab(selectedTab);
              }
            }
            if (Acr.TrackingManager) {
              var packageName = (swiperPagination as HTMLElement).querySelector('.js-tab-link') ? (swiperPagination as HTMLElement).querySelector('.js-tab-link').getAttribute('aria-controls') : undefined;
              updatePackageInObject(packageName);
              if (event) {
                Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
              }

            }
          },
        },
        navigation: {
          nextEl: arrowRight,
          prevEl: arrowLeft,
          disabledClass: 'acr-tab__arrow--disabled',
        },
      }
      tabSwiper = new SwiperJS(swiperContainer, tabSwiperOptions);
    } else if (tabSwiper !== undefined) {
      tabSwiper.destroy(true, true);
    }
  };

  const updatePackageInObject = (packageName) => {
    if (packageName) {
      let newArrowTracking;
      const regexPattern = new RegExp(/packages:.*'/);
      if (acrTab.getAttribute('data-arrow-tracking')) {

        newArrowTracking = acrTab.getAttribute('data-arrow-tracking').replace(regexPattern, `packages:${packageName}'`);
        acrTab.setAttribute('data-arrow-tracking', newArrowTracking);
      }
    }
  };

  const renderTabMobile = (swiper, current: number, total) => {
    let index = current - 1;
    let tabItem = acrTabLink[index];
    return tabItem.outerHTML.replace(activeLinkClass, '');
  }

  const init = (element: HTMLElement) => {
    DeepLink = window.Acr ? window.Acr.DeepLinking || {} : {};
    initSelectors(element);
    getTabSettings();
    setCarouselClasses();
    defineMatchMedia();
    initSwiper(mediaMatchSwiper);
    bindEvents();
    initTabs();
  };

  return {
    init: init,
  };
}